import styled from '@emotion/styled';

const Legal = styled('p')(({ theme }) => ({
  color: theme.colors.gray.medium,
  fontSize: '1.4rem',
}));

export default Legal;
